import { type MarketUpdateDto, patchMarketsId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { MARKET_BY_URL } from "Market/Api/Query/useMarketByIdQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const marketMutationsResource = Resources.base.market.mutations;

export const useUpdateMarketMutation = (marketId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: Partial<MarketUpdateDto>) =>
			patchMarketsId(data, marketId),
		),
		onError: (error) => {
			console.error(`${t(marketMutationsResource.updateMarketError)}:`, error);
		},
		onSuccess: () => {
			toast.success(t(marketMutationsResource.updateMarketSuccess));
			queryClient.invalidateQueries({ queryKey: [MARKET_BY_URL] });
		},
	});
};
